"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initalState = {
    input: "",
    showError: false,
    userSearchedClaims: undefined
};
function reducer(
// biome-ignore lint: -
state = initalState, action) {
    switch (action.type) {
        case "set-input": {
            return Object.assign(Object.assign({}, state), { input: action.input });
        }
        case "set-show-error": {
            return Object.assign(Object.assign({}, state), { showError: action.showError });
        }
        case "set-user-searched-claims": {
            const claims = action.claims.reduce((soFar, current) => {
                const split = current.split(";");
                const contextLower = split[0].toLowerCase();
                const contextClaims = soFar[contextLower] || {};
                const values = split.reduce((sf, c, ix) => (ix < 2 ? sf : sf.concat([c])), []);
                const previousValues = contextClaims[split[1].toLowerCase()];
                const newContextClaims = Object.assign(Object.assign({}, contextClaims), { [split[1].toLowerCase()]: previousValues !== undefined
                        ? previousValues.concat(values)
                        : values });
                return Object.assign(Object.assign({}, soFar), { [contextLower]: newContextClaims });
            }, {});
            return Object.assign(Object.assign({}, state), { userSearchedClaims: claims });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map